import { render, staticRenderFns } from "./PublicationSection.vue?vue&type=template&id=14327a52"
import script from "./PublicationSection.vue?vue&type=script&lang=ts"
export * from "./PublicationSection.vue?vue&type=script&lang=ts"
import style0 from "./PublicationSection.vue?vue&type=style&index=0&id=14327a52&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports